.container {
  position: fixed;
  z-index: 9999;
  bottom: 1.6rem;
  margin: 0 1.6rem;
  width: calc(100% - 3.2rem);
  background: var(--color-grayscale-woodsmoke);
  padding: 1.6rem;
  border-radius: 0.6rem;
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 24px;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}

.content {
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  margin-bottom: 1.2rem;

  p {
    font-size: 1.4rem;
    line-height: 2rem;
    color: var(--color-grayscale-white);
  }

  svg {
    min-width: 2rem;
    transform: translateY(0.4rem);
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
}
